import { useMemo } from 'react'
import { useBreakpoint } from './useBreakpoint'

export function useArtworkGridCols() {
  const is4Col = useBreakpoint('xl', 'up')
  const is3Col = useBreakpoint('mmd', 'up')

  const totalCols = useMemo(
    () => (is4Col ? 4 : is3Col ? 3 : 2),
    [is4Col, is3Col],
  )

  return totalCols
}
